/* eslint-disable react-hooks/exhaustive-deps */
import { MenuItem, SubMenu } from "react-pro-sidebar";
import { ButtonAndDescription } from "../components/TSLandingPage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
  faArrowAltCircleLeft,
  faChartArea,
  faEnvelope,
  faHouse,
  faLocationPinLock,
  faSearch,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { useValidatedUserPayload } from "../app/hooks";
import { useEffect, useState } from "react";
import { useLazyGetPillsByWorkspaceQuery } from "../services/gallusTools";
import {
  lklure,
  loanOfficerUsers,
  mboladian,
  retailUsers,
  secondRetailUsers,
  wholesaleUsers,
  onlyAEPerformanceScoreboardUser,
} from "./CambioRouteObjects";
import {
  faArrows,
  faBalanceScale,
  faBarChart,
  faBriefcase,
  faBuilding,
  faCamera,
  faCompass,
  faDiagramProject,
  faFax,
  faFile,
  faGlasses,
  faHomeUser,
  faMap,
  faMoneyBill1,
  faPrint,
  faRoad,
  faTable,
  faTableCells,
  faTableColumns,
  faTableList,
  faTimes,
  faUserCircle,
  faUserClock,
} from "@fortawesome/free-solid-svg-icons";

export function distributeObjects(
  data: ButtonAndDescription[],
  amountOfRows: number,
): ButtonAndDescription[][] {
  // Sort data alphabetically by title
  const sortedData = data
    .slice()
    .sort((a, b) => a.title.localeCompare(b.title));

  // Create an array to hold the result arrays
  const result: ButtonAndDescription[][] = Array.from(
    { length: amountOfRows },
    () => [],
  );

  // Distribute objects into rows
  sortedData.forEach((item, index) => {
    // Determine which row (sub-array) to put this item in
    const rowIndex = index % amountOfRows;
    result[rowIndex].push(item);
  });

  return result;
}

interface landingPageObject {
  title: string;
  liveboardArray: ButtonAndDescription[];
}

function generateSubMenuItems(
  liveboardArray: ButtonAndDescription[],
  subDomain: string,
) {
  return liveboardArray.map((liveboard) => {
    return (
      <MenuItem>
        <Link
          to={`/${subDomain}/product?productURL=${liveboard.link}&fromMenu=true`}
        >
          <div className="sidebar-item">{liveboard.title}</div>
        </Link>
      </MenuItem>
    );
  });
}

interface GenerateSidebarProps {
  productTitle: string;
  subDomainURL: string;
  staticLandingPageObjects?: landingPageObject[];
  dynamicLandingPageObjectsCode?: orderedDynamicTileCodeInterface[];
  otherObjects?: { sidebarElement: JSX.Element; groupPermission?: string };
  generateViaHardcodedData?: boolean;
}

export function GenerateSidebar(props: GenerateSidebarProps) {
  const [subMenuArray, setSubMenuArray] = useState<JSX.Element[]>([]);
  const [dynamicSubMenuArray, setDynamicSubMenuArray] = useState<
    {
      element: JSX.Element;
      order: number;
    }[]
  >([]);
  const userSession = useValidatedUserPayload();
  const [hasViewingRights, setHasViewingRights] = useState<boolean>(false);
  const [getTilesQuery, getTilesQueryResult] =
    useLazyGetPillsByWorkspaceQuery();

  useEffect(() => {
    const isAllowedToAccessObject = async () => {
      if (props.otherObjects && userSession.cognitoGroups) {
        if (props.otherObjects.groupPermission) {
          setHasViewingRights(
            (userSession.cognitoGroups.includes(
              props.otherObjects.groupPermission,
            ) ||
              userSession.cognitoGroups.includes("Administrator")) ??
              false,
          );
        } else {
          setHasViewingRights(true);
        }
      } else {
        setHasViewingRights(false);
      }
    };

    isAllowedToAccessObject();
  }, [userSession]);

  let extraMenuObject: JSX.Element =
    hasViewingRights && props.otherObjects ? (
      props.otherObjects?.sidebarElement
    ) : (
      <></>
    );

  useEffect(() => {
    if (props.staticLandingPageObjects) {
      props.staticLandingPageObjects.forEach((landingPageObject) => {
        const sortedLiveboardArray: ButtonAndDescription[] =
          landingPageObject.liveboardArray
            .slice()
            .sort((a, b) => a.title.localeCompare(b.title));

        setSubMenuArray((current) => [
          ...current,
          <SubMenu
            {...subMenuDefaultProps}
            title={landingPageObject.title}
            icon={<FontAwesomeIcon className="me-2" icon={faChartArea} />}
          >
            {generateSubMenuItems(sortedLiveboardArray, props.subDomainURL)}
          </SubMenu>,
        ]);
      });
    }

    if (props.dynamicLandingPageObjectsCode) {
      props.dynamicLandingPageObjectsCode.forEach(
        async (dynamicTileCode, index) => {
          try {
            const tiles = await getTilesQuery({
              workspace: dynamicTileCode.dynamicCode.code,
            }).unwrap();
            var sortedButtonArray: ButtonAndDescription[] = [];
            if (tiles.length === 0 && dynamicTileCode.dynamicCode.backup) {
              //Redundant check. Some firewalls block the call but it doesn't register it as a failed call.
              sortedButtonArray = dynamicTileCode.dynamicCode.backup
                .slice()
                .sort((a, b) => a.title.localeCompare(b.title));
            } else {
              sortedButtonArray = tiles
                .slice()
                .sort((a, b) => a.title.localeCompare(b.title));
            }
            setDynamicSubMenuArray((current) => [
              ...current,
              {
                element: (
                  <SubMenu
                    {...subMenuDefaultProps}
                    title={dynamicTileCode.dynamicCode.businessName}
                    icon={
                      <FontAwesomeIcon className="me-2" icon={faChartArea} />
                    }
                  >
                    {generateSubMenuItems(
                      sortedButtonArray,
                      props.subDomainURL,
                    )}
                  </SubMenu>
                ),
                order: dynamicTileCode.order,
              },
            ]);
          } catch {
            if (dynamicTileCode.dynamicCode.backup) {
              const sortedButtonArrayBackup: ButtonAndDescription[] =
                dynamicTileCode.dynamicCode.backup
                  .slice()
                  .sort((a, b) => a.title.localeCompare(b.title));
              setDynamicSubMenuArray((current) => [
                ...current,
                {
                  element: (
                    <SubMenu
                      {...subMenuDefaultProps}
                      title={dynamicTileCode.dynamicCode.businessName}
                      icon={
                        <FontAwesomeIcon className="me-2" icon={faChartArea} />
                      }
                    >
                      {generateSubMenuItems(
                        sortedButtonArrayBackup,
                        props.subDomainURL,
                      )}
                    </SubMenu>
                  ),
                  order: dynamicTileCode.order,
                },
              ]);
            }
          }
        },
      );
    }
  }, []);

  if (props.generateViaHardcodedData && userSession.payload) {
    const subDomain = "cambio";
    const isWholesaleUser = wholesaleUsers.includes(
      userSession.payload["cognito:username"],
    );
    const isRetailUser = retailUsers.includes(
      userSession.payload["cognito:username"],
    );
    const islklureUser = lklure.includes(
      userSession.payload["cognito:username"],
    );
    const ismboladianUser = mboladian.includes(
      userSession.payload["cognito:username"],
    );
    const isSecondRetailUser = secondRetailUsers.includes(
      userSession.payload["cognito:username"],
    );
    const isLoanOfficerUser = loanOfficerUsers.includes(
      userSession.payload["cognito:username"],
    );
    const isOnlyAEPerformanceScoreboardUser = onlyAEPerformanceScoreboardUser.includes(
      userSession.payload["cognito:username"],
    );

    const retailChannelSummary = (
      <MenuItem>
        <Link
          to={`/${subDomain}/product?productURL=pinboard/858d8b5b-3db8-4a5f-bcea-cdf06c05cca0&fromMenu=true`}
        >
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faUserCircle} />
            Retail Channel Summary
          </div>
        </Link>
      </MenuItem>
    );

    const retailChannelSummaryV2 = (
      <MenuItem>
        <Link
          to={`/${subDomain}/product?productURL=pinboard/67eba66c-e1f6-4b3e-990d-0c624873b1e3&fromMenu=true`}
        >
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faUserClock} />
            Retail Channel Summary v2
          </div>
        </Link>
      </MenuItem>
    );

    const wholesaleChannelSummary = (
      <MenuItem>
        <Link
          to={`/${subDomain}/product?productURL=pinboard/afd42ebe-656c-4796-832f-4a68b2d5bc28&fromMenu=true`}
        >
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faRoad} />
            Wholesale Channel Summary
          </div>
        </Link>
      </MenuItem>
    );

    const lockSummary = (
      <MenuItem>
        <Link
          to={`/${subDomain}/product?productURL=pinboard/373e550b-85b2-4531-9f12-938e069efbdd&fromMenu=true`}
        >
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faTimes} />
            Lock Summary
          </div>
        </Link>
      </MenuItem>
    );

    const lockReportMonthToDate = (
      <MenuItem>
        <Link
          to={`/${subDomain}/product?productURL=pinboard/4d398d38-0467-4e18-8e38-8ee170fbfa8e&fromMenu=true`}
        >
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faHomeUser} />
            Lock Report Month to Date
          </div>
        </Link>
      </MenuItem>
    );

    const dailyAverageVolumeByMonth = (
      <MenuItem>
        <Link
          to={`/${subDomain}/product?productURL=pinboard/dfe579f9-cfb0-4371-95a0-b1ec3568939b&fromMenu=true`}
        >
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faFax} />
            Daily Average Volume by Month
          </div>
        </Link>
      </MenuItem>
    );

    const dailyLockReport = (
      <MenuItem>
        <Link
          to={`/${subDomain}/product?productURL=pinboard/04949638-d30c-4528-9167-e7dc94a0040a&fromMenu=true`}
        >
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faBriefcase} />
            Daily Lock Report
          </div>
        </Link>
      </MenuItem>
    );

    const aePerformanceSummary = (
      <MenuItem>
        <Link to={`/${subDomain}/aeperformancesummary`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faMap} />
            AE Performance Summary
          </div>
        </Link>
      </MenuItem>
    );

    const isOnlyAEPerformanceScoreboardUSer = (
      <MenuItem>
        <Link to={`/${subDomain}/aescoreboard`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faTableColumns} />
            AE Performance Scoreboard
          </div>
        </Link>
      </MenuItem>
    );

    const wholesaleRanking = (
      <MenuItem>
        <Link
          to={`/${subDomain}/product?productURL=pinboard/5b856bf6-e181-4854-81bf-d3ae60362070&fromMenu=true`}
        >
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faTable} />
            Wholesale Ranking
          </div>
        </Link>
      </MenuItem>
    );

    const wholesaleExecutiveDashboard = (
      <MenuItem>
        <Link to={`/${subDomain}/wholesalesale`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faTableColumns} />
            Wholesale Executive Dashboard
          </div>
        </Link>
      </MenuItem>
    );

    const retailExecutiveDashboard = (
      <MenuItem>
        <Link to={`/${subDomain}/retail`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faTableColumns} />
            Retail Executive Dashboard
          </div>
        </Link>
      </MenuItem>
    );

    const branchesPerformanceSummary = (
      <MenuItem>
        <Link to={`/${subDomain}/branchesperformancesummary`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faCompass} />
            Branches Performance Summary
          </div>
        </Link>
      </MenuItem>
    );

    const branchesPerformanceScoreboard = (
      <MenuItem>
        <Link to={`/${subDomain}/branchesscoreboard`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faTableCells} />
            Branches Performance Scoreboard
          </div>
        </Link>
      </MenuItem>
    );

    const loPerformanceSummary = (
      <MenuItem>
        <Link to={`/${subDomain}/loperformancesummary`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faDiagramProject} />
            LO Performance Summary
          </div>
        </Link>
      </MenuItem>
    );

    const loPerformanceScoreboard = (
      <MenuItem>
        <Link to={`/${subDomain}/loscoreboard`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faTableList} />
            LO Performance Scoreboard
          </div>
        </Link>
      </MenuItem>
    );

    const otherLiveboardsSubmenu = (
      <SubMenu
        {...subMenuDefaultProps}
        title={"Other"}
        icon={<FontAwesomeIcon className="me-2" icon={faArrows} />}
      >
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/cef8c0f9-9398-49c8-a0ea-e65edffbfb59&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faPrint} />
              Pipeline Overview
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/916c0c86-21f8-4287-8876-09586ce68297&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faUserCircle} />
              Originations Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/b06a5cce-2347-4e93-bf8f-c3fbb2319aa2&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faGlasses} />
              AE Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/e7219ea4-c11e-472b-a072-aafef848ab64&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faCamera} />
              Originations Snapshot
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/c08ef7be-fffe-4f9f-9ba2-712ce22c1e68&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faFile} />
              Retail Region
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/963ac30c-233f-4a6b-84ab-6fa63f76d83a&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBuilding} />
              Retail Branch
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/803e939d-6381-45ae-90f6-6706ac66cd9a&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBriefcase} />
              Retail LO
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/6cf561fd-d685-44cc-b20d-f718903e091e&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faFile} />
              Wholesale Region
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/39bd4c30-2495-4581-9d3a-9de4138bb6a6&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBarChart} />
              Wholesale AE
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/b831d1cb-26f9-42c6-b2c2-6102be2f2ba8&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBalanceScale} />
              Wholesale Broker
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/b53cb3b0-f03d-4d08-b145-6259aae5279e&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faMoneyBill1} />
              Fulfillment Productivity
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
    );

    return (
      <>
        <SubMenu
          {...subMenuDefaultProps}
          title={"CHM"}
          icon={<FontAwesomeIcon className="me-2" icon={faUser} />}
        >
          <MenuItem>
            <Link to={`/${subDomain}`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faHouse} />
                Homepage
              </div>
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              to={`/${subDomain}/product?productURL=pinboards&fromMenu=true`}
              state={{ isLiveboard: false, link: "pinboards/" }}
            >
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faChartArea} />
                Liveboards
              </div>
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to={`/${subDomain}/contactus`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faEnvelope} />
                Contact Us
              </div>
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to={`/${subDomain}/signout`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
                Log Out
              </div>
            </Link>
          </MenuItem>
        </SubMenu>
        <SubMenu
          {...subMenuDefaultProps}
          title={"Search"}
          icon={<FontAwesomeIcon className="me-2" icon={faLocationPinLock} />}
        >
          <MenuItem>
            <Link to={`/${subDomain}/product?productURL=answer&fromMenu=true`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faSearch} />
                Search
              </div>
            </Link>
          </MenuItem>
        </SubMenu>
        {!isLoanOfficerUser  && (
          <div>
            <SubMenu
              {...subMenuDefaultProps}
              title={"Liveboards"}
              icon={
                <FontAwesomeIcon className="me-2" icon={faDiagramProject} />
              }
            >
              {!isWholesaleUser && !islklureUser && !isOnlyAEPerformanceScoreboardUser && <>{retailChannelSummary}</>}
              {!isWholesaleUser && !islklureUser && !isSecondRetailUser && !isOnlyAEPerformanceScoreboardUser && (
                <>{retailChannelSummaryV2}</>
              )}
              {!isRetailUser && !isSecondRetailUser && !isOnlyAEPerformanceScoreboardUser && wholesaleChannelSummary}
              {!isWholesaleUser &&
                !isRetailUser &&
                !islklureUser &&
                !ismboladianUser &&
                !isSecondRetailUser && 
                !isOnlyAEPerformanceScoreboardUser && (
                  <>
                    {lockSummary}
                    {lockReportMonthToDate}
                    {dailyAverageVolumeByMonth}
                    {dailyLockReport}
                  </>
                )}
            </SubMenu>
            <SubMenu
              {...subMenuDefaultProps}
              title={"Scoreboards"}
              icon={<FontAwesomeIcon className="me-2" icon={faChartArea} />}
            >
              {!isSecondRetailUser &&  isOnlyAEPerformanceScoreboardUSer}
              {!isRetailUser && !isSecondRetailUser && !isOnlyAEPerformanceScoreboardUser && <>{wholesaleRanking}</>}
              {!isWholesaleUser &&
                !isRetailUser &&
                !ismboladianUser &&
                !isSecondRetailUser &&
                !isOnlyAEPerformanceScoreboardUser && (
                  <>
                    {wholesaleExecutiveDashboard}
                    {retailExecutiveDashboard}
                  </>
                )}
              {!isWholesaleUser && !isOnlyAEPerformanceScoreboardUser  && (
                <>
                  {branchesPerformanceSummary}
                  {branchesPerformanceScoreboard}
                  {loPerformanceSummary}
                  {loPerformanceScoreboard}
                </>
              )}
            </SubMenu>
            {
            !isWholesaleUser &&
              !isRetailUser &&
              !islklureUser &&
              !ismboladianUser &&
              !isSecondRetailUser &&
              !isOnlyAEPerformanceScoreboardUser &&
              <>{otherLiveboardsSubmenu}</>}
          </div>
        )}
      </>
    );
  } else {
    return (
      <>
        <SubMenu
          {...subMenuDefaultProps}
          title={props.productTitle}
          icon={<FontAwesomeIcon className="me-2" icon={faUser} />}
        >
          <MenuItem>
            <Link to={`/${props.subDomainURL}`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faHouse} />
                Home
              </div>
            </Link>
          </MenuItem>
          {extraMenuObject}
          <MenuItem>
            <Link to={`/${props.subDomainURL}/contactus`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faEnvelope} />
                Contact Us
              </div>
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to={`/${props.subDomainURL}/signout`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
                Log Out
              </div>
            </Link>
          </MenuItem>
        </SubMenu>
        <SubMenu
          {...subMenuDefaultProps}
          title={"Search"}
          icon={<FontAwesomeIcon className="me-2" icon={faLocationPinLock} />}
        >
          <MenuItem>
            <Link
              to={`/${props.subDomainURL}/product?productURL=answer&fromMenu=true`}
            >
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faSearch} />
                Search
              </div>
            </Link>
          </MenuItem>
        </SubMenu>
        {subMenuArray}
        {dynamicSubMenuArray
          .sort((a, b) => a.order - b.order)
          .map((submenu) => {
            return submenu.element;
          })}
      </>
    );
  }
}

export function populateNonEditableArray(
  collectionOfArraysOfButtons: ButtonAndDescription[][],
) {
  const nonEditableLiveboardsArray: string[] = [];
  collectionOfArraysOfButtons.forEach((arrayOfButtons) => {
    arrayOfButtons.forEach((individualLiveboard) => {
      if (individualLiveboard.link) {
        nonEditableLiveboardsArray.push(individualLiveboard.link.slice(9));
      }
    });
  });
  return nonEditableLiveboardsArray;
}

export const subMenuDefaultProps = {
  onPointerEnterCapture: () => {},
  onPointerLeaveCapture: () => {},
  placeholder: "",
};

export interface SubdomainOrgIdObject {
  orgID: number;
  path: string;
  externalInfo?: { subdomain: string; productURL: string };
  editableRightsGroup?: string;
}

export interface dynamicTileCodeInterface {
  code: string;
  businessName: string;
  backup?: ButtonAndDescription[];
}

export interface orderedDynamicTileCodeInterface {
  dynamicCode: dynamicTileCodeInterface;
  order: number;
}
